import { render } from "./SubmissionChat.vue?vue&type=template&id=3f268eea&scoped=true"
import script from "./SubmissionChat.vue?vue&type=script&lang=js"
export * from "./SubmissionChat.vue?vue&type=script&lang=js"

import "./SubmissionChat.vue?vue&type=style&index=0&id=3f268eea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f268eea"

export default script